import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Products from './views/Products.vue';
import ProductDetail from './views/ProductDetail.vue';
import Setup from './views/Setup.vue';
import Topic from './views/Topic.vue';
import { analytics } from '@/lib/util/FirebaseConfig';
import { kioskSetup } from '@/lib/KioskSetup';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/index.html', redirect: '/' },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/products/:topicId?',
      props: true,
      meta: {
        protected: false,
        title: 'Products',
      },
      component: Products,
    },
    {
      path: '/product-detail/:productId',
      props: true,
      meta: {
        protected: false,
        title: 'Product Detail',
      },
      component: ProductDetail,
    },
    {
      path: '/topic/:topicId',
      props: true,
      meta: {
        protected: false,
        title: 'Topic',
      },
      component: Topic,
    },
    {
      path: '/setup',
      meta: {
        protected: true,
        title: 'Kiosk Setup',
      },
      component: Setup,
    },
    {
      path: '*', // catch-all route
      redirect: '/',
    }
  ],
  // scrollBehavior: (to, from, savedPosition) => {
  //   if (savedPosition) {
  //     return savedPosition;
  //   }
  //   else {
  //     return { x: 0, y: 0 };
  //   }
  // },
});

// check if authenticated on each route change
router.beforeEach((to, from, next) => {
  let screenName = 'Home';
  if ( to.meta ) {
    document.title = to.meta.title || 'Kiosk';
    screenName = to.meta.title || 'Home';
  }
  console.log(`logEvent screen_view: screen_name=${screenName}`);
  analytics.logEvent("screen_view", { kioskId: kioskSetup.kioskId, app_name: 'Kiosk', screen_name: screenName });
  next();
});

export default router;
